<template>
  <section class="imageCropper-section">
    <div class="imageCropper-container">
      <div class="imageCropper-previews" v-show="ready">
        <div class="imageCropper-image-preview">
          <label>Perfil</label>
          <img class="crop-preview1 clip-circle" :src="destination">
        </div>
        <div class="imageCropper-image-preview">
          <label>Network</label>
          <img class="crop-preview2" :src="destination">
        </div>
      </div>
      <div class="imageCropper-content">
        <img class="master-image" ref="image" :src="src">
      </div>
      <div class="imageCropper-buttons">
        <button class="imageCropper-cancelBtn" @click="cancelHandler">CANCEL</button>
        <button class="imageCropper-okBtn" @click="okHandler">OK</button>
      </div>

    </div>
  </section>
</template>

<script>
import 'cropperjs/dist/cropper.css';
import Cropper from 'cropperjs';

export default {
  name: 'ImageCropper',
  props: {
    src: String,
  },

  components: {
    Cropper,
  },
  data() {
    return {
      image: {},
      cropper: {},
      destination: {},
      dataUrl: null,
      ready: false,
    };
  },
  methods: {
    cancelHandler() {
      this.$emit('cancelCrop');
    },
    okHandler() {
      this.$emit('okCrop');
      this.$emit('croppedUrl', this.destination);
    },
  },
  created() {},
  mounted() {
    this.image = this.$refs.image;
    this.cropper = new Cropper(this.image, {
      zoomable: true,
      scalable: true,
      dragMode: 'move',
      aspectRatio: 1 / 1,
      crop: () => {
        const canvas = this.cropper.getCroppedCanvas();
        this.destination = canvas.toDataURL('image/png');
        // console.log('DESTINATION:' + this.destination);
        this.ready = true;
      },
    });
  },
};
</script>

<style lang="scss">
.imageCropper-section {
  // background-color: teal;
  position: fixed;
  top: 10vh;
  bottom: 4vh;
  left: 2vw;
  right: 2vw;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
}
.imageCropper-container {
  position: relative;
  background-color: #dddddd;
  height: auto;
  width: 96vw;
  padding: 2% 4% 0% 4%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.imageCropper-content {
  position: relative;
  background-color: #aaa;
  width: 88vw;
  height: 50vh;
}
.cropper-container {
  height: 50vh !important;
  width: 88vw !important;
}
.master-image {
  width: 88vw;
  height: 300px;
}
.imageCropper-previews {
  position: relative;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-around;

  .imageCropper-image-preview {
    position: relative;
    color: #888;
    font-weight: bolder;
    font-size: 1.3rem;
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    justify-content: flex-end;
  }
}

.crop-preview1 {
  position: relative;
  margin-bottom: 8px;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  box-shadow: 8px 8px 12px 0 rgba(0, 0, 0, 0.2);
  object-fit: cover;
}
// .clip-circle {
//   // clip-path: circle(60px at center);
// }
.crop-preview2 {
  position: relative;
  margin-bottom: 8px;
  width: 120px;
  height: 120px;
  // border: 1px solid black;
  box-shadow: 8px 8px 12px 0 rgba(0, 0, 0, 0.2);
  object-fit: cover;
  object-position: top;
}
.imageCropper-buttons {
  display: flex;
}
.imageCropper-cancelBtn {
  cursor: pointer;
  color: var(--button-background);
  background-color: var(--button-text);
  border-radius: var(--input-borderRadius);
  border: 1px solid var(--button-outline);
  outline: none;
  margin: 20px 10px 20px 0px;
  height: 6vh;
  width: 40%;
}
.imageCropper-okBtn {
  cursor: pointer;
  color: var(--button-text);
  background-color: var(--button-background);
  border-radius: var(--input-borderRadius);
  border: 1px solid var(--button-outline);
  outline: none;
  margin: 20px 0px 20px 10px;
  height: 6vh;
  width: 60%;
}

@include media('>=tablet') {
  .imageCropper {
    top: 120px;
    bottom: 4vh;
    left: 2vw;
    right: 2vw;
  }
  .imageCropper-container {
    width: 60vw;
  }
  .imageCropper-content {
    width: 52vw;
  }
  .cropper-container {
    width: 52vw !important;
  }
  .master-image {
    width: 52vw;
  }
}
@include media('<=phone') {
  .imageCropper-section {
    top: 120px;
    bottom: 1vh;
    left: 2vw;
    right: 2vw;
  }
  .imageCropper-container {
    width: 100vw;
  }
}
</style>
